import * as React from 'react';
import {useSelector} from 'react-redux';
import Box from '@mui/material/Box';
import {Link} from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import Tooltip from '@mui/material/Tooltip';
import {RootState} from '../../redux/store';
import Logo from '../Logo/logo';
import LogOut from '../LogOut/logOut';
import {IconStyle} from '../../styles/iconStyle/iconStyle';

const Nav = () => {
  const {loggedIn} = useSelector((state: RootState) => state.auth);
  return (
    <>
      <Logo />
      <Box position="absolute" top="0px" right="0px">
        {loggedIn ? (
          <IconStyle>
            <Tooltip title="Home" placement="right">
              <Link to="/home">
                <HomeIcon />
              </Link>
            </Tooltip>
            <LogOut />
          </IconStyle>
        ) : (
          <p> </p>
        )}
      </Box>
    </>
  );
};
export default Nav;
